import { MouseEvent } from "react";
import { useTranslation } from "@localization/useTranslation";
import { RiskTreatmentType, treatmentChipColor, treatmentChipTranslationKey } from "./riskTreatmentType";
import TreatmentChipBase from "./TreatmentChipBase";

interface RiskTreatmentChipProps {
    treatmentType: RiskTreatmentType;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
}

// The treatment-type pill for the Treatment column: "Mitigating" / "Risk accepted" / "Avoided". The
// mitigation plan's sub-status lives in its own column via RiskMitigationStatusChip.
function RiskTreatmentChip({ treatmentType, onClick }: RiskTreatmentChipProps) {
    const { translateString } = useTranslation();

    return (
        <TreatmentChipBase label={translateString(treatmentChipTranslationKey[treatmentType])} color={treatmentChipColor[treatmentType]} onClick={onClick} />
    );
}

export default RiskTreatmentChip;
